module.exports = __webpack_public_path__ + "img/wheelbarrow_back.5cec52c1.png";